import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import SingleSelectQuestions from '../../../components/Questions/SingleSelectQuestions';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';

import './styles.css';
// import ReferGraphic from '../img/refer-graphic.svg';

const ReferPage = props => {
  const questions = {
    //title: 'Question 7: Supporting Autonomy',
    type: 'multiple',
    text: (
      <Fragment>
        <UnClickableScreenReader text="Which of the following are reasons for offering a range of resources and services as options? Select all that apply" />
        <strong>
          Which of the following are reasons for offering a range of resources and services as options?
        </strong>
        <br />
        (select all that apply)
      </Fragment>
    ),
    result: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
    feedback: {
      correct: '',
      correctNode: (
        <div>
          <p>
            Correct! All the reasons stated above are correct. Respecting someone’s autonomy and agency means accepting that they get to choose if,
            when, and how to engage with the resources shared. You can encourage but can’t compel someone to seek support before they feel
            they are ready which at times may feel uncomfortable. If someone declines your referral, you can continue to support them by
            letting them know that you respect their choice and that you hope they will consider seeking help when they’re ready. For example,
            you may say, <span style={{ fontStyle: 'italic' }}>“It’s your decision to make and I hope you’ll keep these options in mind.”</span>
          </p>
        </div>
      ),
      incorrect: '',
      incorrectNode: (
        <div>
          <p>
            <strong>All</strong> of the reasons stated above are correct. Respecting someone’s autonomy and agency means accepting that they get to
            choose if, when, and how to engage with the resources shared. You can encourage but can’t compel someone to seek support before they feel
            they are ready which at times may feel uncomfortable. If someone declines your referral, you can continue to support them by letting
            them know that you respect their choice and that you hope they will consider seeking help when they’re ready. For example, you may say,{' '}
            <span style={{ fontStyle: 'italic' }}>“It’s your decision to make and I hope you’ll keep these options in mind.”</span>
          </p>
        </div>
      ),
      all: ''
    }
  };
  const options = [
    {
      prefix: 'A',
      result: 'correct',
      optionText:
        'Someone may feel more comfortable accessing services outside of the University.'
    },
    {
      prefix: 'B',
      result: 'correct',
      optionText:
        'Someone may feel more comfortable accessing services within the University.'
    },
    {
      prefix: 'C',
      result: 'correct',
      optionText:
        'Offering multiple options can help minimize your personal bias.'
    },
    {
      prefix: 'D',
      result: 'correct',
      optionText:
        'Some resources may cater to someone’s needs better than others.'
    },
    {
      prefix: 'E',
      result: 'correct',
      optionText:
        'Some resources may be better able to deliver culturally competent care.'
    },
    {
      prefix: 'F',
      result: 'correct',
      optionText:
        'Knowing that there are many possible sources of support can instill a sense of hope.'
    },
    {
      prefix: 'G',
      result: 'correct',
      optionText:
        'Someone may have already accessed some of the resources you’re suggesting.'
    },
    {
      prefix: 'H',
      result: 'correct',
      optionText:
        'Offering multiple options allows for a personalized approach to care.'
    }
  ];
  return (
    <EducationModuleLayout
      progressStage={3}
      childTitle="Refer"
      progressType="refer"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader
                text={`2. Share resources and services`}
              />
              <h2 className="txt-blue no-bold no-margin">
                2. Share resources and services
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader
                text={`Prior to sharing resources and services, ensure that the person is open to receiving a referral. For example, you may ask, 
                “There are a few resources that may be helpful. Would you like to explore these together?” You can also find out if they’ve accessed 
                any resources or services prior and then offer a range of new options. For example, you might say, “Have you tried accessing any 
                services on- or off- campus? How did that go? I know of some other services that you might find useful.”`}
              />
              <p>
                Prior to sharing resources and services, ensure that the person is open to receiving a referral. For example, you may ask, {' '}
                <span className="font-italic">
                  “There are a few resources that may be helpful. Would you like to explore these together?”
                </span>
              </p>
              <p>
                You can also find out if they’ve accessed any resources or services prior and then offer a range of new options.
                For example, you might say, {' '}
                <span className="font-italic">
                  “Have you tried accessing any services on- or off- campus? How did that go? I know of some other
                  services that you might find useful.”
                </span>
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <SingleSelectQuestions
        questions={questions}
        options={options}
        questionType="refer"
        nextRoute={url.REFER_D}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

ReferPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const ReferC = connect.role(ReferPage);

export default ReferC;



// WEBPACK FOOTER //
// ./src/containers/Refer/ReferC/index.jsx